export const TRANSPORT_ICONS = {
    BUS: 'directions_bus',
    METRO: 'subway',
    TRAIN: 'train',
    TRAM: 'tram',
    SHIP: 'directions_boat'
}
